import { Chart } from 'primereact/chart';
import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';

export class ClientInvoiceReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            stackedData: {
                labels: [],
                datasets: []
            },

            stackedOptions: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        };

        this.loadProjects = this.loadProjects.bind(this);
    }

    componentDidMount() {
        if (this.props.accountId)
            this.loadProjects();
    }

    componentDidUpdate(prevProps) {
        if (this.props.accountId && prevProps.accountId !== this.props.accountId)
            this.loadProjects();
    }

    loadProjects() {
        var scope = this;
        scope.setState({ loading: true });
        var token = localStorage.getItem("token");
        fetch('api/Account/invoiceReport?id=' + this.props.accountId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var stackedData = scope.state.stackedData;
                    stackedData.labels = result.labels;
                    stackedData.datasets = result.dataSets.map(dataset => {
                        return {
                            type: 'bar',
                            label: dataset.status,
                            backgroundColor: scope.getRandomColor(),
                            data: dataset.amounts
                        }
                    });

                    scope.setState({ stackedData: stackedData, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    render() {
        return (
            <div>
                <h3>Сумма счетов из CRM</h3>
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <Chart type="bar" data={this.state.stackedData} options={this.state.stackedOptions} />}
            </div>
        )
    }
}